__webpack_require__.p = "https://assets.simple.life/dev/static/staging/d8306fc6/";